import React, { useState, useEffect, lazy } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../../../assets/appLogo.png'
import checkEmail from '../../../assets/Group 24.png'
import { useDispatch, useSelector } from 'react-redux';
import { getStarted, resendEmail } from '../../services/operations/authAPI';
import Loader from '../../Loader/Loader';


const VerifyEmail = () => {

    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch()
    const loading = useSelector((state) => state.auth.loading)

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const base64Param = params.get('data');
        const emailFromParams = base64Param ? atob(base64Param) : '';

        if (emailFromParams) {
            setEmail(decodeURIComponent(emailFromParams));
        }
    }, [location.search]);

    const handleResendEmail = async () => {
        const payload = {
            email: email
        }
        await dispatch(resendEmail(payload))
    }

    return (
        <div className='registration-started'>
            {loading && <Loader />}
            <img src={logo} className='app-image' alt="app-logo" style={{ alignItems: "center" }} onClick={() => navigate("/")} />
            <div className='registration-form' style={{ width: "30%" }}>

                <img src={checkEmail} alt='check-email' loading={lazy} style={{ width: "166px", height: "166px" }} />
                <p className='check-email-heading'>Check Your Email & complete the verification</p>
                <div className='check-email-desc'>
                    <p>We’ve sent you verification link to<br />
                        <span style={{ fontWeight: "600" }}>{email}</span>
                    </p>
                </div>
                <br /><br /><br />
                <br />
                <p className='resend-email-link'>Didn’t get the email, click here to <a onClick={handleResendEmail}>resend</a></p>
            </div>

        </div>


    )
}

export default VerifyEmail